import React from 'react';
import Image from 'next/image';
import Link from 'next/link';

import { globalConst } from 'modules/global';

interface IProps {
  name?: string;
  image?: string;
  specialty?: string;
  url: string;
}

const TeacherCard: React.FC<IProps> = ({ image, name, specialty, url }) => (
  <Link
    href={`${globalConst.pageNames.TEACHER}/${url}`}
    className="flex h-40 flex-col items-center justify-center gap-y-1 rounded-lg bg-white"
  >
    <div className="flex min-h-12 min-w-12 items-center justify-center overflow-hidden rounded-full border border-gray-200 bg-gray-50">
      <Image
        src={image || '/images/default-no-logo.webp'}
        alt={name?.slice(0, 1) || 'user profile avatar'}
        width={image ? 48 : 18}
        height={image ? 48 : 18}
        className="object-contain "
        title="Kurs ishlab chiquvchining rasmi"
      />
    </div>
    <span className="line-clamp-2 text-xs font-medium">{name}</span>
    <span className="w-30 line-clamp-2 text-center text-[0.625rem] text-gray-500">{specialty}</span>
  </Link>
);

export default TeacherCard;
